module.exports = __webpack_public_path__ + "img/home_white_24dp.298fbb1c.svg";